<template>
  <v-dialog v-model="dialog" width="450">
    <v-card>
      <v-toolbar dark flat>
        <v-toolbar-title>{{
          title == null ? $t("common.confirmDelete") : title
        }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close-dialog')">{{
          $t("common.close")
        }}</v-btn>
        <v-btn color="error" text @click="$emit('confirmed-delete')">{{
          $t("common.delete")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialogDelete",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: null
    }
  }
};
</script>
